import React from 'react'
import { Link } from 'react-router-dom';

const CancelPage = () => {
    return (
        <>
            <section className='cancel-section'>
                <div className="container">
                    <div className='page-not-found '>
                        <h3 data-aos="fade-left" data-aos-duration="1500" data-aos-easing="linear">❌ Payment Canceled.</h3>
                        <p data-aos="flip-left" data-aos-duration="1500" data-aos-easing="linear">
                            Your payment was not completed. You can try again.
                        </p>
                        <button className='custom_btn' data-aos="zoom-out-up" data-aos-duration="1500" data-aos-easing="linear">
                            <Link to="/">Go To Home</Link>
                        </button>
                    </div>
                </div>
            </section>
        </>
    );
};

export default CancelPage;
